import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapZionNationalPark from "../components/Maps/zion-national-park";
import ZionNationalParkInfo from "../components/TripInfo/zion-national-park";

class ZionNationalPark extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Zion National Park: 3-Day Itinerary"
        category="National Parks"
        slug="zion-national-park-itinerary"
        excerpt="Red sandstone cliffs, slot canyons, and the Virgin River — Angels Landing, The Narrows, and Kolob Canyons in Utah's most dramatic park."
        tags={["National Parks", "Hiking", "Utah", "Southwest", "Slot Canyons"]}
        readTime="7 min read"
        mapComponent={<MapZionNationalPark />}
        whereToStay={[
          { name: 'Hotels in Springdale', type: 'Main Gateway · steps from entrance', url: 'https://www.booking.com/searchresults.html?ss=Springdale%2C+Utah' },
          { name: 'Cable Mountain Lodge', type: 'Boutique Hotel · Springdale, UT', url: 'https://www.booking.com/searchresults.html?ss=Springdale%2C+Utah' },
          { name: 'Hotels in St. George', type: 'Budget Option · 45 min away', url: 'https://www.booking.com/searchresults.html?ss=St.+George%2C+Utah' },
        ]}
      >
        <ZionNationalParkInfo />
      </StaticPostLayout>
    );
  }
}

export default ZionNationalPark;
